import { render, staticRenderFns } from "./searchWrap.vue?vue&type=template&id=4c8fcd88&scoped=true&"
import script from "./searchWrap.vue?vue&type=script&lang=js&"
export * from "./searchWrap.vue?vue&type=script&lang=js&"
import style0 from "./searchWrap.vue?vue&type=style&index=0&id=4c8fcd88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fcd88",
  null
  
)

export default component.exports